import { combineReducers } from 'redux-immutable'
import { handleActions } from 'redux-actions'
import { Map, List } from 'immutable'

import * as actions from './actions'

const classifications = handleActions(
  {
    [actions.fetchClassificationsSuccess]: (state, action) => state.merge(action.payload),
    [actions.createClassificationsSuccess]: (state, action) => state.concat(action.payload),
  },
  List(),
)

const status = handleActions(
  {
    [actions.fetchClassificationsSuccess]: state => state.set('loaded', true).set('loading', false),
    [actions.fetchClassificationsPending]: state => state.set('loading', true).set('loaded', false),
    [actions.fetchClassificationsFailed]: state => state.set('loading', false),
  },
  Map(),
)

export default combineReducers({ classifications, status })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/classification/reducer.js